import { render, staticRenderFns } from "./store-area-list.vue?vue&type=template&id=57c6fa2c"
import script from "./store-area-list.vue?vue&type=script&lang=js"
export * from "./store-area-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports